export default "__VITE_ASSET__DlMWGPMX__"